import React from 'react';
import { useTranslation } from 'react-i18next';
import OptionCard from './OptionCard';
const ChooseStep = ({ onUpload, onScratch }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "flex flex-col gap-10" },
        React.createElement("div", { className: "text-center" },
            React.createElement("h1", { className: "text-4xl font-semibold text-gray-800" }, t('pitchCreation.chooser.title')),
            React.createElement("p", { className: "mx-auto mt-4 max-w-xl text-xl text-gray-700 md:hidden" }, t('pitchCreation.chooser.subtitle')),
            React.createElement("p", { className: "mx-auto mt-4 hidden max-w-xl text-xl text-gray-700 md:block" }, t('pitchCreation.chooser.subtitleDesktop'))),
        React.createElement("div", { className: "grid gap-4 md:grid-cols-2" },
            React.createElement(OptionCard, { icon: "cloud_upload", title: t('pitchCreation.chooser.uploadOption'), onClick: onUpload }),
            React.createElement(OptionCard, { icon: "edit_note", title: t('pitchCreation.chooser.scratchOption'), onClick: onScratch }))));
};
export default ChooseStep;
